import { jsx as _jsx } from "react/jsx-runtime";
import "./bounding.style.css";
export const ASecondBounce = ({ children, boxStyle = {}, wrapperStyle = {} }) => {
    return (_jsx("div", { className: "stage", style: wrapperStyle, children: _jsx("div", { className: "box bounce-5", style: boxStyle, children: children }) }));
};
